import { Link } from 'react-router-dom';
import { dossiers } from '@/mocks/dossiers';
import DossierCard from '@/components/feature/DossierCard';

export default function FeaturedDossiers() {
  const list = dossiers.slice(0, 6);

  return (
    <section id="dossiers" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 border-b border-background-200 pb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">精选档案 / ARCHIVE</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">最近完成的拆解</h2>
          </div>
          <Link
            to="/dossiers"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-800 transition-colors hover:border-foreground-800"
          >
            浏览全部 8 篇
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {list.map((dossier, index) => (
            <DossierCard key={dossier.id} dossier={dossier} order={index} />
          ))}
        </div>
      </div>
    </section>
  );
}